/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import { dotPop, resizeDimensions } from '../Utils';
import FontKeys from '../FontKeys';

export default class SaveCreationPictureView extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {Phaser.GameObjects.Image} canvasRef
   * @param {Hud} container
   */
  constructor(scene,canvasRef, container, closeCallback) {
    super(scene);

    this.canvasRef = canvasRef;
    this.container = container;
    this.closeCallback = closeCallback;

    this.bg = null;

    this.btnClose = null;
    this.btnSave = null;
    this.btnPrint = null;
    this.lblInstructions = null;

    this.domElement = null;

    this.bg = this.scene.add.rectangle(0,0,this.scene.scale.width, this.scene.scale.height, 0x000000).setAlpha(0.1)
      .setInteractive()
      .setOrigin(0);
    this.add(this.bg);

    this.mainView = this.scene.add.container();

    this.pinkStripes = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._PinkStripes, this).setOrigin(0);
    this.pinkStripes.scaleY = this.scene.scale.height;
    this.pinkStripes.alpha = 0.2;
    ABCyaPhaser.Tweens.addTween(this.pinkStripes, 220, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.btnClose = this.scene.add.container(0,0);
    this.mainView.add(this.btnClose);
    const closeBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BtnSaveClose, this.btnClose).setInteractive()
      .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleClose, this);
    this.btnClose.setSize(closeBg.width, closeBg.height);
    const closeTxt = ABCyaPhaser.Text.addText(0,52,22, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.exit_button'), this.btnClose);

    this.btnSave = this.scene.add.container(0,0);
    this.mainView.add(this.btnSave);
    const saveBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BtnSave, this.btnSave).setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleSave, this);
    const saveTxt = ABCyaPhaser.Text.addText(0,52,22, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.save_button'), this.btnSave);

    const bgFrame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._save_Screen);
    this.imgWithBg = this.scene.add.renderTexture(0,0, bgFrame.width, bgFrame.height).setOrigin(0);
    this.imgWithBg.draw(bgFrame, 0, 0);

    // add the text
    const txt = ABCyaPhaser.Text.addText(bgFrame.width / 2,75, 48, 0xb15cc6, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.save_popup_text'), this).setWordWrapWidth(575)
      .setVisible(false);
    this.imgWithBg.draw(txt);

    this.makeDisplayImage(this.imgWithBg);

    this.mainView.add(this.imgWithBg);
    this.add(this.mainView);

    this.btnPrint = this.scene.add.container(0,0);
    const printBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BtnPrint, this.btnPrint).setInteractive()
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handlePrint, this);
    this.btnPrint.setSize(printBg.width, printBg.height);
    const printTxt = ABCyaPhaser.Text.addText(0,52,22, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.print_button'), this.btnPrint);

    this.layoutRatio();

    const destY = this.imgWithBg.y;
    this.imgWithBg.y = -this.imgWithBg.height;
    ABCyaPhaser.Tweens.addTween(this.imgWithBg, 600, { y: destY }, Phaser.Math.Easing.Quadratic.In);

    const time = 400;
    this.btnClose.scale = 0;
    this.btnSave.scale = 0;
    this.btnPrint.scale = 0;
    let wait = 600;

    dotPop(this.btnPrint, time, wait);
    wait += time * 1.2;

    dotPop(this.btnSave, time, wait);
    wait += time * 1.2;
    dotPop(this.btnClose, time, wait);
  }

  handleClose () {
    this.scene.tweens.killTweensOf(this.btnClose);
    this.scene.tweens.killTweensOf(this.btnSave);
    this.scene.tweens.killTweensOf(this.imgWithBg);
    if (this.btnPrint) {
      this.scene.tweens.killTweensOf(this.btnPrint);
      ABCyaPhaser.Tweens.addTween(this.btnPrint, 300, { scale: 0, alpha: 0 }, Phaser.Math.Easing.Linear);
    }

    ABCyaPhaser.Tweens.addTween(this.btnClose, 400, { scale: 1.1, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.btnSave, 300, { scale: 0, alpha: 0 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.imgWithBg, 440, { y: this.scene.scale.height }, Phaser.Math.Easing.Linear, () => this.handleOutroFinishing());
  }

  handleOutroFinishing () {
    this.bg.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.pinkStripes, 220, { alpha: 0 }, Phaser.Math.Easing.Linear, () => this.outroComplete());
  }

  outroComplete () {
    this.destroy();
    this.closeCallback();
  }

  handleSave () {
    this.imgWithBg.snapshot(async (image) => {
      try {
        await ABCyaLib.PrintSave.instance.saveImage(image, { fileName: ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.save_filename') });
      }
      catch {

      }
    });
  }

  /**
   * 
   * @param {Phaser.GameObjects.RenderTexture} bgCanvas 
   */
  makeDisplayImage (bgCanvas) {
    bgCanvas.x = 32;
    bgCanvas.y = this.scene.scale.height / 2 - bgCanvas.height / 2;
    const b = { x: 0, y: 0, width: bgCanvas.width, height: bgCanvas.height };
    const drawRect = { x: 0,y: 166,width: 710,height: 510 };
    this.drawRect = drawRect;

    const resizeD = resizeDimensions(this.canvasRef.width, this.canvasRef.height, drawRect.width, drawRect.height);
    const dx = drawRect.x + (drawRect.width / 2 - resizeD.width / 2);
    const dy = drawRect.y + (drawRect.height / 2 - resizeD.height / 2);
    const originalScale = this.canvasRef.scale;
    bgCanvas.draw(this.canvasRef.setScale(resizeD.scale), dx, dy);
    this.canvasRef.scale = originalScale;
  }

  handlePrint () {
    this.imgWithBg.snapshot(async (image) => {
      try {
        await ABCyaLib.PrintSave.instance.printImage(image);
      }
      catch {

      }
    });
  }

  layoutRatio () {
    const rightX = this.scene.scale.width - (this.scene.scale.width - (this.imgWithBg.x + this.imgWithBg.width)) / 2;
    this.btnClose.x = rightX;
    this.btnSave.x = rightX;
    this.btnClose.y = this.scene.scale.height * 0.7 + this.btnClose.height / 2;
    this.btnSave.y = this.scene.scale.height * 0.5;
    this.mainView.add([this.btnPrint, this.btnSave]);
    if (this.btnPrint) {
      this.btnPrint.x = rightX;
      this.btnPrint.y = this.scene.scale.height * 0.3 - this.btnPrint.height / 2;
      this.mainView.add(this.btnPrint);
    }

    this.imgWithBg.x = 32;
    this.imgWithBg.y = this.scene.scale.height / 2 - (this.imgWithBg.height / 2);
  }
}